import {createEntityAdapter} from '@reduxjs/toolkit';

export const financialEngagementsAdapter = createEntityAdapter({
	selectId: (financialEngagement) => financialEngagement.financialEngagementId,
});